import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import Select from './Select';
import Button from './Button';
import { PAGE_SIZE_OPTIONS } from '../../hooks/useTablePagination';

export default function TablePagination({
  currentPage,
  totalPages,
  totalItems,
  startIndex,
  endIndex,
  pageSize,
  onPageChange,
  onPageSizeChange,
  itemLabel = 'items',
  className = '',
  onExport,
  exportLabel = 'Export',
}) {
  if (totalItems === 0) {
    return null;
  }

  return (
    <div className={`px-4 py-3 border-t border-slate-200 bg-slate-50 flex flex-wrap items-center justify-between gap-3 ${className}`}>
      <div className="text-sm text-slate-700">
        Showing <span className="font-medium">{startIndex}</span> to{' '}
        <span className="font-medium">{endIndex}</span> of{' '}
        <span className="font-medium">{totalItems}</span> {itemLabel}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        {onExport && (
          <Button size="sm" variant="secondary" onClick={onExport}>
            <ArrowDownTrayIcon className="h-4 w-4 mr-1.5" />
            {exportLabel}
          </Button>
        )}
        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-600">Rows</span>
          <Select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="text-sm w-20"
          >
            {PAGE_SIZE_OPTIONS.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </Select>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-700">Page</span>
          <Select
            value={currentPage}
            onChange={(e) => onPageChange(Number(e.target.value))}
            className="text-sm w-20"
          >
            {Array.from({ length: totalPages }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </Select>
          <span className="text-sm text-slate-700">of {totalPages}</span>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
